import React from 'react';
import { useNavigate } from 'react-router-dom';

const ValidationResults = () => {
  const navigate = useNavigate();

  // Mock validation data
  const image = {
    image_id: 1,
    filename: '731219993_0898.tif',
    validation_status: 'fail',
  };

  const validationChecks = [
    { name: 'File Format', status: 'pass', message: 'Valid format: .tif', icon: '✅' },
    { name: 'File Integrity', status: 'pass', message: 'File integrity OK', icon: '✅' },
    { name: 'Histogram Clipping', status: 'pass', message: 'Exposure OK (Background: 224, Contrast: 193)', icon: '✅' },
    { name: 'Skew Detection', status: 'pass', message: 'Skew OK: 0.50°', icon: '✅' },
    { name: 'Fold Detection', status: 'fail', message: 'Fold detected at bottom-left', icon: '❌' },
    { name: 'Out of Focus', status: 'pass', message: 'IN-FOCUS - 8.3% of content zones are blurry (5/60 tiles)', icon: '✅' },
    { name: 'Object Detection', status: 'pass', message: 'No foreign objects detected', icon: '✅' },
    { name: 'Orientation Detection', status: 'pass', message: 'Orientation correct (0°)', icon: '✅' },
    { name: 'Duplicate Detection', status: 'pass', message: 'Unique image (SSIM: 0.234)', icon: '✅' },
  ];

  const passedCount = validationChecks.filter(c => c.status === 'pass').length;
  const failedCount = validationChecks.filter(c => c.status === 'fail').length;

  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8fafc',
    },
    header: {
      backgroundColor: 'white',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      borderBottom: '1px solid #e5e7eb',
    },
    headerContent: {
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '20px 30px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    titleSection: {
      display: 'flex',
      alignItems: 'center',
      gap: '15px',
    },
    logo: {
      width: '48px',
      height: '48px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '12px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '24px',
      fontWeight: 'bold',
    },
    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#1f2937',
      margin: 0,
    },
    subtitle: {
      fontSize: '14px',
      color: '#6b7280',
      margin: '2px 0 0 0',
    },
    backButton: {
      padding: '10px 20px',
      backgroundColor: '#6b7280',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '14px',
      fontWeight: '600',
      cursor: 'pointer',
    },
    mainContent: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '40px 30px',
    },
    summaryCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
      padding: '32px',
      marginBottom: '30px',
    },
    summaryTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#1f2937',
      marginBottom: '24px',
    },
    summaryGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '24px',
    },
    summaryItem: {
      textAlign: 'center',
    },
    summaryLabel: {
      fontSize: '13px',
      color: '#6b7280',
      marginBottom: '8px',
      textTransform: 'uppercase',
      fontWeight: '600',
    },
    summaryValue: {
      fontSize: '36px',
      fontWeight: 'bold',
    },
    resultsCard: {
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
    },
    resultsHeader: {
      padding: '20px 24px',
      borderBottom: '1px solid #e5e7eb',
      backgroundColor: '#f9fafb',
    },
    resultsTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#1f2937',
      margin: 0,
    },
    checkList: {
      padding: '24px',
    },
    checkItem: {
      display: 'flex',
      alignItems: 'start',
      gap: '16px',
      padding: '20px',
      borderRadius: '8px',
      marginBottom: '12px',
      border: '2px solid',
      transition: 'all 0.2s',
    },
    checkItemPass: {
      backgroundColor: '#f0fdf4',
      borderColor: '#86efac',
    },
    checkItemFail: {
      backgroundColor: '#fef2f2',
      borderColor: '#fca5a5',
    },
    checkIcon: {
      fontSize: '32px',
      flexShrink: 0,
    },
    checkContent: {
      flex: 1,
    },
    checkName: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '6px',
    },
    checkMessage: {
      fontSize: '14px',
      color: '#6b7280',
      lineHeight: '1.5',
    },
    checkStatus: {
      fontSize: '12px',
      fontWeight: '600',
      padding: '4px 12px',
      borderRadius: '12px',
      textTransform: 'uppercase',
    },
    statusPass: {
      backgroundColor: '#10b981',
      color: 'white',
    },
    statusFail: {
      backgroundColor: '#ef4444',
      color: 'white',
    },
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <div style={styles.titleSection}>
            <div style={styles.logo}>C</div>
            <div>
              <h1 style={styles.title}>Validation Results</h1>
              <p style={styles.subtitle}>{image.filename}</p>
            </div>
          </div>
          <button
            onClick={() => navigate(-1)}
            style={styles.backButton}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
          >
            ← Back
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div style={styles.mainContent}>
        {/* Summary Card */}
        <div style={styles.summaryCard}>
          <h2 style={styles.summaryTitle}>Validation Summary</h2>
          <div style={styles.summaryGrid}>
            <div style={styles.summaryItem}>
              <div style={styles.summaryLabel}>Total Checks</div>
              <div style={{ ...styles.summaryValue, color: '#3b82f6' }}>
                {validationChecks.length}
              </div>
            </div>
            <div style={styles.summaryItem}>
              <div style={styles.summaryLabel}>Passed</div>
              <div style={{ ...styles.summaryValue, color: '#10b981' }}>
                {passedCount}
              </div>
            </div>
            <div style={styles.summaryItem}>
              <div style={styles.summaryLabel}>Failed</div>
              <div style={{ ...styles.summaryValue, color: '#ef4444' }}>
                {failedCount}
              </div>
            </div>
          </div>
        </div>

        {/* Validation Checks */}
        <div style={styles.resultsCard}>
          <div style={styles.resultsHeader}>
            <h2 style={styles.resultsTitle}>Detailed Check Results</h2>
          </div>
          <div style={styles.checkList}>
            {validationChecks.map((check, index) => (
              <div
                key={index}
                style={{
                  ...styles.checkItem,
                  ...(check.status === 'pass' ? styles.checkItemPass : styles.checkItemFail),
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateX(4px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateX(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={styles.checkIcon}>{check.icon}</div>
                <div style={styles.checkContent}>
                  <div style={styles.checkName}>{check.name}</div>
                  <div style={styles.checkMessage}>{check.message}</div>
                </div>
                <div
                  style={{
                    ...styles.checkStatus,
                    ...(check.status === 'pass' ? styles.statusPass : styles.statusFail),
                  }}
                >
                  {check.status}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidationResults;